export const PRODUCT_OPTION_TYPES_SERVER = `
  fragment OptionTypes on OptionType {
    id
    name
    key
    position
    presentation
  }
`;
